module.exports = __webpack_public_path__ + "img/module7.71f224b.png";